import { useState } from "react";

import { IonRow } from "@ionic/react";
import { SEO, Loading, PageTitle } from "../components";
import { importAll } from "../helpers/helpers";

const images = importAll(
  require.context("../assets/bio", false, /\.(png|jpeg|jpg|svg|webp)$/)
);

const formatAltText = (filename) => {
  return filename
    .replace(/-/g, " ") // заменяем дефисы на пробелы
    .replace(/_/g, " - ") // заменяем подчеркивания на разделитель
    .replace(/\.[^/.]+$/, ""); // удаляем расширение файла
};

export const About = ({ project, config }) => {
  const [loading, setLoading] = useState(true);

  const seo = config?.SEO.about;
  const projectDescription = config?.projectDescription;

  return (
    <div id="AboutPage" className="about-page">
      <SEO
        title={seo?.title}
        description={seo?.description}
        keywords={seo?.keywords}
        ogImage={`/assets/og_image/${project}.jpg`}
      />
      {loading && <Loading />}

      <div className="about-main-img">
        <img
          src={`/assets/about_${project}_main.webp`}
          alt={formatAltText("/assets/about_image.webp")}
          onLoad={() => setLoading(false)}
          draggable="false"
        />
      </div>
      <div className="about-container">
        <div className="about-text shadow-no-border">
          <PageTitle pageTitle="About" />
          <img
            src={`/assets/about_${project}.webp`}
            alt={formatAltText(`/assets/about_${project}.webp`)}
            className="bio-image"
            draggable="false"
            loading="lazy"
            decoding="async"
            fetchpriority="auto"
            onLoad={() => setLoading(false)}
          />
          {projectDescription?.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </div>
      </div>

      <ImageBox />
    </div>
  );
};

export const ImageBox = () => {
  return (
    <IonRow id="AllImageContainer" className="all-img-container">
      {images.map((image, idx) => (
        <div key={idx} className="img-box ">
          <img
            key={idx}
            src={image}
            alt={formatAltText(image)}
            className="shadow-img image3"
            style={{ border: "3px solid white", pointerEvents: "none" }}
            draggable="false"
            loading="lazy"
            decoding="async"
            fetchpriority="auto"
          />
        </div>
      ))}
    </IonRow>
  );
};
